"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Administrator = void 0;
const IAward_1 = require("../IAward");
class Administrator {
    constructor() {
        this.name = 'Administrator';
        this.description = 'Have the most cards in play with no tags';
    }
    getScore(player) {
        let score = player.getNoTagsCount();
        return score + IAward_1.getAdditionalScore(player);
    }
}
exports.Administrator = Administrator;
//# sourceMappingURL=Administrator.js.map